import { render, staticRenderFns } from "./QuotationStepResourceWithoutModalityRecursal.vue?vue&type=template&id=90372408"
import script from "./QuotationStepResourceWithoutModalityRecursal.vue?vue&type=script&lang=js"
export * from "./QuotationStepResourceWithoutModalityRecursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports